import React from 'react';
import crossPlatformSvg from '../../assets/icons/cross-platform-icon.svg';

interface CrossPlatformIconProps {
  size?: number;
  className?: string;
}

const CrossPlatformIcon: React.FC<CrossPlatformIconProps> = ({ size = 48, className = '' }) => {
  return (
    <img 
      src={crossPlatformSvg} 
      alt="Cross Platform Icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default CrossPlatformIcon;
